import { render } from "./Celebration.vue?vue&type=template&id=477820a8&scoped=true"
import script from "./Celebration.vue?vue&type=script&lang=js"
export * from "./Celebration.vue?vue&type=script&lang=js"

import "./Celebration.vue?vue&type=style&index=0&id=477820a8&scoped=true&lang=scss"
import "./Celebration.vue?vue&type=style&index=1&id=477820a8&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-477820a8"]])

export default __exports__